const MB = 1000000;
export const MAX_FILE_SIZE = 10 * MB;
export const ANDROID_DEFAULT_RATIO = "4:3";
